<template>
  <div>
    <v-list dense>
      <div
          v-for="order in invoice.orders"
          :key="order.id"
      >
        <InvoiceListItemInfoOrder
            :ccy="ccy"
            :order="order"
            :sourceStatuses="sourceStatuses"
            :buyout="buyout"
        ></InvoiceListItemInfoOrder>
      </div>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-content class="ml-14">
          <v-list-item-title>
            <b>Итого: {{total | number}} {{ccy}}</b>
          </v-list-item-title>
          <v-list-item-subtitle v-if="hasBills">
            <v-btn
              class="mt-2"
              color="primary"
              text
              x-small
              @click="$emit('show-bills', invoice.bills)"
            >
              <v-icon left>mdi-receipt</v-icon>
              Электронный чек
            </v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import InvoiceListItemInfoOrder from '@/components/InvoiceListItemInfoOrder'

export default {
  name: 'InvoiceListItemInfo',
  components: {InvoiceListItemInfoOrder},
  computed: {
    hasBills () {
      return this.invoice.bills && this.invoice.bills.length > 0
    },
    total () {
      if (this.invoice.amountDiff) {
        return this.invoice.amount - this.invoice.amountDiff
      } else {
        return this.invoice.amount
      }
    }
  },
  data () {
    return {
      fullDescribe: {}
    }
  },
  props: {
    buyout: {
      type: Object
    },
    buyoutItem: {
      type: Object
    },
    ccy: {
      type: String
    },
    invoice: {
      required: true,
      type: Object
    },
    sourceStatuses: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>